var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0103 16.0049L12.0103 12.0049L8.01025 16.0049",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0103 12.0049V21.0049",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4002 18.3949C21.3756 17.8631 22.146 17.0217 22.5901 16.0035C23.0341 14.9852 23.1264 13.8481 22.8524 12.7716C22.5784 11.695 21.9537 10.7404 21.0769 10.0583C20.2001 9.37625 19.1211 9.0056 18.0102 9.00487H16.7502C16.4475 7.83411 15.8834 6.7472 15.1002 5.82586C14.3169 4.90452 13.3351 4.17272 12.2283 3.68547C11.1216 3.19823 9.91876 2.96823 8.71033 3.01275C7.5019 3.05727 6.31928 3.37517 5.25139 3.94253C4.1835 4.5099 3.25813 5.31197 2.54484 6.28845C1.83155 7.26493 1.3489 8.3904 1.13319 9.58026C0.917484 10.7701 0.974319 11.9934 1.29943 13.1581C1.62454 14.3229 2.20946 15.3987 3.01021 16.3049",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0103 16.0049L12.0103 12.0049L8.01025 16.0049",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.0102539 0.00488281H24.0103V24.0049H0.0102539V0.00488281Z",
  fill: "white"
})));

function SvgUploadCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/UploadCloud.827c4ce0.svg";
export { ForwardRef as ReactComponent };